<div>
  <p>
    Autorisiere die Löschung von <strong>{{ deviceToRetire.customerDeviceName }}</strong>
  </p>

  <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
</div>
